import React, { useEffect, useState } from 'react';
import './DisplayKeys.css';
import { supabase } from './supabaseClient';
import { FaTrash, FaLock } from 'react-icons/fa';
import logo from './assets/logo.png';

const DisplayKeys = () => {
  const [licenseKeys, setLicenseKeys] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchKeys = async () => {
    const { data: { session }, error: sessionError } = await supabase.auth.getSession();
    if (sessionError || !session?.user) return;

    const { data, error: fetchError } = await supabase
      .from('robot_licenses')
      .select('*')
      .eq('user_id', session.user.id);

    if (fetchError) {
      console.error('Fetch error:', fetchError);
      return;
    }

    const filtered = (data || []).filter(item => item.key); // Only actual license keys
    setLicenseKeys(filtered);
    setLoading(false);
  };

  useEffect(() => {
    fetchKeys();
  }, []);

  const deactivateKey = async (id) => {
    const holdUntil = new Date();
    holdUntil.setDate(holdUntil.getDate() + 3); // Freeze for 3 days

    const { error } = await supabase
      .from('robot_licenses')
      .update({ used: false, hold_until: holdUntil.toISOString() })
      .eq('id', id);

    if (error) {
      alert('Failed to deactivate key');
    } else {
      alert('Key deactivated. Will remain frozen for 3 days.');
      fetchKeys();
    }
  };

  const deleteKey = async (id) => {
    if (!window.confirm('Are you sure you want to permanently delete this key?')) return;

    const { error } = await supabase
      .from('robot_licenses')
      .delete()
      .eq('id', id);

    if (error) {
      alert('Failed to delete key');
    } else {
      fetchKeys();
    }
  };

  return (
    <div className="display-container">
      <div className="top-bar">
        <h2>My License Keys</h2>
        <div className="logo-container">
          <img src={logo} alt="logo" className="logo-circle" />
        </div>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <div className="key-grid">
          {licenseKeys.map((key) => (
            <div className={`key-card ${key.used ? 'active' : 'inactive'}`} key={key.id}>
              <h4>{key.display_name}</h4>
              <p>{key.key}</p>
              <p>Status: <strong>{key.used ? 'Active' : 'Unused'}</strong></p>
              {key.hold_until && (
                <p className="hold-warning">Frozen until: {new Date(key.hold_until).toLocaleDateString()}</p>
              )}
              <div className="key-actions">
                {!key.used && (
                  <button className="deactivate-btn" onClick={() => deactivateKey(key.id)}>
                    <FaLock /> Deactivate
                  </button>
                )}
                <button className="delete-btn" onClick={() => deleteKey(key.id)}>
                  <FaTrash /> Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DisplayKeys;